import { Button, Modal } from "antd";
import { useState } from "react";

function ConfirmButton({ onClick, confirmTitle, confirmContent, ...rest }) {
  const [open, setOpen] = useState<boolean>(false);

  return <>
    <Modal
        title={confirmTitle}
        open={open}
        onOk={onClick}
        cancelText="Abbrechen"
        onCancel={() => setOpen(false)}
      >
        <>{ confirmContent }</>
    </Modal>
    <Button {...rest} onClick={() => setOpen(true)} />
    </>
}

export default ConfirmButton;